import _ from "lodash";
import React, { useState, useEffect, useContext } from "react";
import { Col, Row, Modal, Card, Tab, Nav } from "react-bootstrap";
import { notificationService } from "service/NotificationService";
import { apiService } from "service/ApiService";
import StoreContext from "contexts/StoreContext";
import SaveButton from "components/Buttons/SaveButton";
import PricelistPriceTab from "components/Custom/PricelistPriceTab";
import PricelistVatItem from "components/Custom/PricelistVatItem";

import { useTranslation } from "react-i18next";

export default function PricelistsPriceModal({ productId, productName, openModal }) {
  const {
    t,
  } = useTranslation();

  const { storeId, setStoreId } = useContext(StoreContext);

  const [pricelists, setPricelists] = useState([]);
  const [productPrices, setProductPrices] = useState([]);
  const [vats, setVats] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [defaultNavItem, setDefaultNavItem] = useState(null);
  const [pricelistData, setPricelistData] = useState({});
  const [show, setShow] = useState(false);

  const fetchPrices = async () => {
    const productPrices = await apiService.get(`api/v1/pricelist-prices/product/${productId}`);
    setPricelistData({});
    setProductPrices(productPrices);
    setShow(true);
  };

  const fetchPricelists = async () => {
    const _pricelists = await apiService.get(`api/v1/pricelists/store/${storeId}`);
    const activePricelists = _pricelists.filter((e) => !e.deleted);
    if (activePricelists.length !== 0) setDefaultNavItem(`pricelist-nav-item-${activePricelists[0].id}`);
    setPricelists(activePricelists);
  };

  const handlePriceChange = (data) => {
    pricelistData[data.pricelistId] = data;
    setPricelistData(pricelistData);
  };

  const save = () => {
    setIsDisabled(true);

    apiService
      .postJson(`api/v1/pricelist-prices/product/${productId}`, _.values(pricelistData))
      .then((resp) => {
        notificationService.notifySuccess(t("messages.productPricesUpdatedSuccessfully"));
        setIsDisabled(false);
        setShow(false);
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
        setIsDisabled(false);
      });
  };

  const fetchVats = async () => {
    try {
      console.log(`FetchVats...`);
      const response = await apiService.get(`api/v1/vats`);
      const availableVats = response.map((el) => {
        return {
          value: el.id,
          label: el.percent,
        };
      });
      setVats(availableVats);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!storeId) return;
    fetchPricelists();
  }, [storeId]);

  useEffect(() => {
    if (openModal === 0) return;
    fetchPrices();
  }, [openModal]);

  useEffect(() => {
    fetchVats();
  }, []);

  const closeModal = () => setShow(false);

  return (
    <>
      <Modal size="lg" dialogClassName="my-modal" show={show} onHide={closeModal} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Body>
          <Card>
            <Card.Header>
              <Card.Title as="h4">{t("messages.productPricesSuffix")}{productName}</Card.Title>
            </Card.Header>
            <Card.Body>
              <Tab.Container id="pricelist-prices" defaultActiveKey={defaultNavItem}>
                <Nav role="tablist" variant="tabs">
                  {pricelists.map((el) => (
                    <PricelistVatItem id={el.id} title={el.name} />
                  ))}
                </Nav>
                <Tab.Content>
                  {pricelists.map((el) => {
                    const pricelistPrice = productPrices.find((m) => m.pricelist.id === el.id);
                    const defaultPrice = _.get(pricelistPrice, "price", null);
                    const defaultVatId = _.get(pricelistPrice, "vat.id", null);
                    return <PricelistPriceTab id={el.id} handler={handlePriceChange} price={defaultPrice} vatId={defaultVatId} vats={vats} />;
                  })}
                </Tab.Content>
              </Tab.Container>
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Row className="float-left" style={{ width: "100%" }}>
            <Col>
              <SaveButton handler={save} disabled={isDisabled} />
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
}
